import { useCallback } from "react";

import {
    exploreSignalsRestApi,
    goToSignalsWebhookGateway,
    isSignalsRestApiAccountEnabled,
    manageSignalsRestApi,
    manageSignalsWebhook,
} from "../utils/signalsIntegrationActions";

import useSignalsApiData from "./useSignalsApiData";
import useSignalsRestApiData from "./useSignalsRestApiData";

export type SignalsWebhookIntegrationActions = {
    isConfigured: boolean;
    isEnabled: boolean;
    hasAccess: boolean;
    onManageClick: VoidFunction;
    onUpgradeClick: VoidFunction;
};

export type SignalsRestApiIntegrationActions = {
    isConfigured: boolean;
    isAccountEnabled: boolean;
    onManageClick: VoidFunction;
    onUpgradeClick: VoidFunction;
};

export type SignalsIntegrationActions = {
    webhook: SignalsWebhookIntegrationActions;
    restApi: SignalsRestApiIntegrationActions;
};

export const useSignalsIntegrationActions = (): SignalsIntegrationActions => {
    const webhookData = useSignalsApiData();
    const restApiData = useSignalsRestApiData();

    const onWebhookManageClick = useCallback((): void => {
        manageSignalsWebhook({ isConfigured: webhookData.isConfigured, data: webhookData.data });
    }, [webhookData.isConfigured, webhookData.data]);

    const onRestApiManageClick = useCallback((): void => {
        manageSignalsRestApi(restApiData.isConfigured);
    }, [restApiData.isConfigured]);

    return {
        webhook: {
            isConfigured: webhookData.isConfigured,
            isEnabled: webhookData.isEnabled,
            hasAccess: webhookData.hasAccess,
            onManageClick: onWebhookManageClick,
            onUpgradeClick: goToSignalsWebhookGateway,
        },
        restApi: {
            isConfigured: restApiData.isConfigured,
            isAccountEnabled: isSignalsRestApiAccountEnabled(),
            onManageClick: onRestApiManageClick,
            onUpgradeClick: exploreSignalsRestApi,
        },
    };
};
